module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"at":"um","on":"am"},"fr":{"at":"à","on":"le"},"it":{"at":"alle","on":"il"}}')
  delete Component.options._Ctor
}
